/** Images locales fixes — servies depuis /demo/ (client/public/demo), mises en cache navigateur + PWA. */
export const DEMO_DECOY_IMAGES = [
  '/demo/01.webp',
  '/demo/02.webp',
  '/demo/03.webp',
  '/demo/04.webp',
  '/demo/05.webp',
  '/demo/06.webp',
  '/demo/07.webp',
  '/demo/08.webp',
] as const;

export function pickRandomDecoyIndex(exclude?: number): number {
  if (DEMO_DECOY_IMAGES.length <= 1) return 0;
  let idx: number;
  do {
    idx = Math.floor(Math.random() * DEMO_DECOY_IMAGES.length);
  } while (idx === exclude);
  return idx;
}
